/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import ThemeIconProvider from './ThemeIconProvider';

interface EventHistoryLocationIconProps {
  color?: string;
}

/*
 * Defines the Design Language System (DLS) Event History Location Icon component for the
 * Event Popup.
 */
export const EventHistoryLocationIcon = ({color = dlsColor('grey3')}: EventHistoryLocationIconProps) => {
  return (
    <ThemeIconProvider name='EventHistoryLocationIcon' color={color} legacyIcon={(
      <svg width="13" height="18" viewBox="0 0 13 18" fill="none">
        <path d="M6.22648 16.2731L6.62498 16.603L7.02357 16.2731C8.25723 15.252 9.55215 13.5082 10.534 11.7453C11.0284 10.8575 11.4533 9.94738 11.7561 9.09838C12.0556 8.25855 12.25 7.4388 12.25 6.74405C12.25 4.11491 10.1822 1 6.62498 1C3.0678 1 1 4.11491 1 6.74405C1 7.4388 1.19447 8.25855 1.49396 9.09838C1.79673 9.94738 2.22159 10.8575 2.71603 11.7453C3.69787 13.5082 4.99282 15.252 6.22648 16.2731Z" stroke={color} strokeWidth="1.5"/>
        <path d="M6.62516 9.28615C7.89082 9.28615 8.91683 8.26014 8.91683 6.99449C8.91683 5.72883 7.89082 4.70282 6.62516 4.70282C5.35951 4.70282 4.3335 5.72883 4.3335 6.99449C4.3335 8.26014 5.35951 9.28615 6.62516 9.28615Z" stroke={color} strokeWidth="1.5"/>
      </svg>
    )} />
  );
};
